import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Trophy, Medal, Award, Star } from 'lucide-react';
import { periodLabel } from './BadgeAnnouncement';

const API = `${window.location.origin}/api`;

const RANK = {
  1: { Icon: Trophy, bg: 'bg-amber-50', text: 'text-amber-600', label: '1.' },
  2: { Icon: Medal, bg: 'bg-slate-100', text: 'text-slate-500', label: '2.' },
  3: { Icon: Award, bg: 'bg-orange-50', text: 'text-orange-700', label: '3.' },
};

const Item = ({ badge }) => {
  if (badge.type === 'mention') {
    return (
      <div data-testid="profile-badge" className="flex items-center gap-3 p-3 rounded-xl bg-fuchsia-50 border border-fuchsia-100">
        <div className="w-11 h-11 rounded-xl bg-fuchsia-100 flex items-center justify-center flex-shrink-0">
          <Star className="w-6 h-6 text-fuchsia-500" />
        </div>
        <div className="min-w-0">
          <div className="text-sm font-semibold text-gray-900">Özel Mansiyon</div>
          <div className="text-xs text-gray-500">{periodLabel(badge.period)}</div>
        </div>
      </div>
    );
  }
  const r = RANK[badge.rank] || RANK[1];
  const Icon = r.Icon;
  return (
    <div data-testid="profile-badge" className="flex items-center gap-3 p-3 rounded-xl bg-white border border-gray-100 shadow-sm">
      <div className={`w-11 h-11 rounded-xl ${r.bg} flex items-center justify-center flex-shrink-0`}>
        <Icon className={`w-6 h-6 ${r.text}`} />
      </div>
      <div className="min-w-0">
        <div className="text-sm font-semibold text-gray-900">
          <span className={r.text}>{r.label} Sıra</span> · {badge.tagName}
        </div>
        <div className="text-xs text-gray-500">{periodLabel(badge.period)}</div>
      </div>
    </div>
  );
};

export default function UserBadges({ userId }) {
  const [badges, setBadges] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const url = userId ? `${API}/badges/user/${userId}` : `${API}/badges/my`;
    axios.get(url)
      .then((res) => setBadges(res.data.badges || []))
      .catch(() => setBadges([]))
      .finally(() => setLoading(false));
  }, [userId]);

  return (
    <div className="glass rounded-2xl p-6" data-testid="profile-badges-section">
      <div className="flex items-center space-x-3 mb-6">
        <div className="bg-amber-100 p-3 rounded-full">
          <Trophy className="w-5 h-5 text-amber-600" />
        </div>
        <div>
          <h2 className="text-lg font-bold text-gray-900">Rozetlerim</h2>
          <p className="text-sm text-gray-500">Kazandığınız performans ve mansiyon rozetleri</p>
        </div>
      </div>
      {loading ? (
        <div className="text-sm text-gray-400 py-4">Yükleniyor...</div>
      ) : badges.length === 0 ? (
        <div className="text-center py-8 text-gray-400">
          <Trophy className="w-10 h-10 mx-auto mb-2 opacity-30" />
          <p className="text-sm">Henüz rozet kazanılmadı. Performansınızı sürdürün! 💪</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3">
          {[...badges].sort((a, b) => (b.period || '').localeCompare(a.period || '')).map((b) => <Item key={b.id} badge={b} />)}
        </div>
      )}
    </div>
  );
}
